import config from "./config";
var axios = config();

export default {
  get() {
    return axios.get("/api/CourseEquivalents");
  },

  post(courseEquivalent) {
    return axios.post("/api/CourseEquivalents", courseEquivalent);
  },

  put(id, courseEquivalent) {
    return axios.put("/api/CourseEquivalents/" + id, courseEquivalent);
  },

  delete(id) {
    return axios.delete("/api/CourseEquivalents/" + id);
  },

  getById(id) {
    return axios.get("/api/CourseEquivalents/" + id);
  },

  getByTermAndAsurite(termId, asurite) {
    return axios.get(
      "/api/CourseEquivalents?termId=" + termId + "&asuriteId=" + asurite
    );
  },

  postFiles(courseEquivalentId, files) {
    var formData = new FormData();
    files.forEach(function(file) {
      // add each file to the form data
      formData.append("files", file);
    });
    return axios.post(
      "/api/CourseEquivalents/" + courseEquivalentId + "/files",
      formData
    );
  },

  getFiles(courseEquivalentId) {
    return axios.get("/api/CourseEquivalents/" + courseEquivalentId + "/files");
  },

  getStatuses() {
    return axios.get("/api/CourseEquivalents/statuses");
  },
};
